import React from 'react'
import { Route as ReactRouteRouter } from 'react-router-dom'

const Route = props => (
	<ReactRouteRouter {...props} />
)

export default Route
